import { PureComponent } from 'react';
import PropTypes from 'prop-types';
import {numberFormatter} from "@dnhb/formatters";
import replaceValueInEvent from '../../../../helper/replaceValueInEvent';

class CoreNumericInputComponent extends PureComponent {
  constructor(props) {
    super(props);

    this.format = this.format.bind(this);
    this.onBlurHandler = this.onBlurHandler.bind(this);
    this.onChangeHandler = this.onChangeHandler.bind(this);
    this.onFocusHandler = this.onFocusHandler.bind(this);
    this.onKeyPressHandler = this.onKeyPressHandler.bind(this);
    this.onKeyDownHandler = this.onKeyDownHandler.bind(this);
    this.onKeyUpHandler = this.onKeyUpHandler.bind(this);
    this.onClickHandler = this.onClickHandler.bind(this);
    this.previousKey = null;

    this.state = {
      value: props.value,
      disabled: props.disabled,
      stringValue: this.format(props.value),
      cursorPosition: 0,
      valueContainsComma: false,
    };
  }

  componentDidUpdate(prevProps) {
    if (this.props.value !== prevProps.value) {
      const newValue = this.format(this.props.value);
      this.setState({ stringValue: newValue, value: this.props.value, valueContainsComma: newValue.includes(',') });
    }
    this.updateCursorPosition();
  }

  handleCommaRemoval({value, previousKey,cursorIsAfterComma} ) {
    let numberFormatted = 0;
    let cursorPositionInNewString = null;
    let floatValue = 0;
    const integerPart = Math.trunc(value).toString();
    const fractionalPart = Math.ceil((value % 1).toFixed(2) * 100).toString();
    if(previousKey === 'Delete'){
      const fractionalPartLastDigit = fractionalPart.split("").pop();
      let newFranctionalPart = fractionalPartLastDigit + "0";
      const newVal = `${integerPart}.${newFranctionalPart}`;
      numberFormatted = this.format(Number(newVal), cursorIsAfterComma, 2);
      floatValue = parseFloat(numberFormatter(Number(newVal), 2, cursorIsAfterComma).replace(/\./g, '').replace(',', '.'));
      cursorPositionInNewString = numberFormatted.search(',') !== -1 ? numberFormatted.search(',') : numberFormatted.length;
    }else {
      const integerPartWithoutLastDigit = integerPart.substring(0, integerPart.length - 1);
      const newValue = `${integerPartWithoutLastDigit}.${fractionalPart}`;
      numberFormatted = this.format(Number(newValue), true, 2);
      floatValue = parseFloat(numberFormatter(Number(newValue), 2, true).replace(/\./g, '').replace(',', '.'));
      cursorPositionInNewString = numberFormatter(Number(newValue), 2, true).search(',');
      if(this.props && this.props.prefix){
        cursorPositionInNewString += this.props.prefix.length;
      }
    }
    if(floatValue === 0){
      numberFormatted = ""
      floatValue = ""
    }

    if(floatValue % 1 === 0) numberFormatted = numberFormatted.split(',')[0];
    return {cursorPositionInNewString, numberFormatted, floatValue};
  }

  onChangeHandler(e) {
    let numberFormatted = '';
    let numericValue = null;
    let cursorPositionInNewString = 0;
    const cursorPosition = e.target.selectionStart;

    if (this.previousKey === '.') {
      const untilPoint = e.target.value.substr(0, cursorPosition - 1);
      const afterPoint = e.target.value.substr(cursorPosition);

      e.target.value = `${untilPoint},${afterPoint}`;
    }

    const valueWithoutPreAndPostFix = e.target.value.replace(
      this.props.prefix,
      '',
    ).replace(
      this.props.postfix,
      '',
    );

    // Remove disallowed characters
    let regex = /[^\d.,]/;
    if (this.props.signed) {
      regex = /[^-\d.,]/;
    }

    let valueAfterCharacterRemoval = valueWithoutPreAndPostFix.replace(regex, '');
    if (valueAfterCharacterRemoval !== '') {
      numericValue = valueAfterCharacterRemoval;
    }

    let floatValue = numericValue !== null ? parseFloat(numericValue.replace(/\./g, '').replace(',', '.')) : null;
    if(isNaN(floatValue)) floatValue = null;

    if (this.props.signed && (valueWithoutPreAndPostFix === '-' || valueWithoutPreAndPostFix === '-0')) {
      // Only a - is placed, the string value should not be formatted and the value should not be formatted
      // When you do, the value will be an empty string

      numberFormatted = valueWithoutPreAndPostFix;
      cursorPositionInNewString = valueWithoutPreAndPostFix.length;
    } else if (e.target.value !== this.props.prefix) {
      numericValue = valueAfterCharacterRemoval;

      const cursorIsAfterComma = e.target.value.search(',') !== -1 && e.target.value.search(',') < cursorPosition;
      const charBeforeCursor = e.target.value.charAt(cursorPosition - 1);
      const cursorIsDirectlyAfterComma = charBeforeCursor === ',';

      const numberTillCursor = e.target.value.substring(0, cursorPosition).replace(/[^\d-]/g, '');
      if(this.state.valueContainsComma && !e.target.value.includes(',') && e.target.value !== this.props.prefix.trim() && e.target.value !== ""){
        const obj = {
          stringValue : this.state.stringValue,
          value : this.state.value,
          previousKey : this.previousKey,
          cursorIsAfterComma : cursorIsAfterComma
        };
        ({numberFormatted, cursorPositionInNewString, floatValue } = this.handleCommaRemoval(obj));
      }else {
        numberFormatted = this.format(floatValue, cursorIsAfterComma);

        if (cursorIsDirectlyAfterComma) {
          cursorPositionInNewString = numberFormatted.search(',') + 1;
          if (cursorPositionInNewString === 0) {
            // no comma in new string place cursor at the end
            cursorPositionInNewString = numberFormatted.length - this.props.postfix.length;
          }
        } else {
          const CursorAfterNumber = numberTillCursor.length;
          const regExp = new RegExp(`((?:-?\\D*\\d){${CursorAfterNumber}})`);
          const match = numberFormatted.match(regExp);
          //
          cursorPositionInNewString = numberFormatted.length - this.props.postfix.length;
          if (match !== null) {
            cursorPositionInNewString = match[0].length;

            if (numberFormatted.includes('-') || this.previousKey === '-') {
              cursorPositionInNewString--;
            }
          }
        }
      }
    }

    this.setState({
      stringValue: numberFormatted,
      value: floatValue,
      cursorPosition: cursorPositionInNewString,
      valueContainsComma: numberFormatted.includes(','),
    });

    this.props.onChangeHandler(replaceValueInEvent(e, floatValue));
  }

  onKeyPressHandler(e) {
    this.props.onKeyPressHandler(replaceValueInEvent(e, this.state.value));
  }

  onKeyDownHandler(e) {
    const { key } = e;
    this.previousKey = key;

    if (e.target.selectionStart === e.target.selectionEnd) {
      if (key === 'Backspace') {
        if (e.target.selectionStart <= this.props.prefix.length) {
          e.preventDefault();
          return;
        }

        const effectedChar = e.target.value.charAt(e.target.selectionStart - 1);
        if (effectedChar === '.') {
          const beforePoint = this.state.stringValue.substr(0, e.target.selectionStart - 1);
          const afterCursor = this.state.stringValue.substr(e.target.selectionStart);

          this.setState({
            cursorPosition: e.target.selectionStart - 1,
            stringValue: beforePoint + afterCursor,
          });
        }
      }

      if (key === 'Delete') {
        const effectedChar = e.target.value.charAt(e.target.selectionStart);
        if (effectedChar === '.') {
          const untilCursor = this.state.stringValue.substr(0, e.target.selectionStart);
          const afterPoint = this.state.stringValue.substr(e.target.selectionStart + 1);

          this.setState({
            cursorPosition: e.target.selectionStart,
            stringValue: untilCursor + afterPoint,
          });
        }
      }

      if (key === '-') {
        if (this.props.signed) {
          if (this.state.stringValue.indexOf('-') !== -1) {
            // Ingore multiple - signs
            e.preventDefault();
            return;
          }

          if (e.target.selectionStart - this.props.prefix.length > 0) {
            // Ingore multiple - signs
            e.preventDefault();
            return;
          }
        }
      }
    }

    this.props.onKeyDownHandler(replaceValueInEvent(e, this.state.value));
  }

  onKeyUpHandler(e) {
    this.forceCursorInBoundries(e);

    this.props.onKeyUpHandler(replaceValueInEvent(e, this.state.value));
  }

  onBlurHandler(e) {
    this.props.onBlurHandler(replaceValueInEvent(e, this.state.value));
  }


  onClickHandler(e) {
    this.props.onClickHandler(replaceValueInEvent(e, this.state.value));
  }

  onFocusHandler(e) {
    this.props.onFocusHandler(replaceValueInEvent(e, this.state.value));
  }

  format(floatValue, forceDecimals, decimals) {
    return numberFormatter(
      floatValue,
      decimals || this.props?.decimals,
      forceDecimals || this.props?.alwaysDecimals,
      (this.props?.prefix ?? ''),
      (this.props?.postfix ?? ""),
    );
  }

  forceCursorInBoundries(e) {
    if (e.target.selectionStart <= this.props.prefix.length && e.target.selectionEnd <= this.props.prefix.length) {
      this.setState((state, props) => ({ ...state, cursorPosition: props.prefix.length })) 
      this.updateCursorPosition();
    }

    if (this.state.stringValue.indexOf(this.props.postfix) !== -1) {
      const maxPosition = this.state.stringValue.length - this.props.postfix.length;
      if (e.target.selectionStart >= maxPosition && e.target.selectionEnd >= maxPosition) {
        this.setState((state) => ({ ...state, cursorPosition: maxPosition })) 
        this.updateCursorPosition();
      }
    }
  }

  updateCursorPosition() {
    if (this.textInput === document.activeElement) {
      this.textInput.selectionStart = this.state.cursorPosition;
      this.textInput.selectionEnd = this.state.cursorPosition;
    }
  }

  render() {
    const {
      name, placeholder, id, className, readOnly, autoFocus, disabled, inputMode
    } = this.props;

    return (
      <input
        ref={(textInput) => {
          this.textInput = textInput;
        }}
        readOnly={readOnly}
        type="text"
        className={className}
        value={this.state.stringValue}
        name={name}
        id={id}
        placeholder={placeholder}
        onBlur={this.onBlurHandler}
        onFocus={this.onFocusHandler}
        onChange={this.onChangeHandler}
        onKeyUp={this.onKeyUpHandler}
        onKeyPress={this.onKeyPressHandler}
        onClick={this.onClickHandler}
        onKeyDown={this.onKeyDownHandler}
        autoFocus={autoFocus}
        disabled={disabled}
        data-testid="coreInput"
        inputMode={inputMode || 'decimal'}
      />
    );
  }
}

CoreNumericInputComponent.propTypes = {
  signed: PropTypes.bool,
  autoFocus: PropTypes.bool,
  readOnly: PropTypes.bool,
  name: PropTypes.string,
  id: PropTypes.string,
  className: PropTypes.string,
  prefix: PropTypes.string,
  decimals: PropTypes.number,
  alwaysDecimals: PropTypes.bool,
  placeholder: PropTypes.string,
  postfix: PropTypes.string,
  value: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.number,
  ]),
  onChangeHandler: PropTypes.func,
  onBlurHandler: PropTypes.func,
  onFocusHandler: PropTypes.func,
  onKeyPressHandler: PropTypes.func,
  onKeyUpHandler: PropTypes.func,
  onKeyDownHandler: PropTypes.func,
  onClickHandler: PropTypes.func,
};

CoreNumericInputComponent.defaultProps = {
  signed: false,
  autoFocus: false,
  readOnly: false,
  placeholder: null,
  className: null,
  name: null,
  prefix: '',
  postfix: '',
  decimals: 0,
  alwaysDecimals: false,
  id: null,
  value: '',
  onChangeHandler: () => {
  },
  onBlurHandler: () => {
  },
  onFocusHandler: () => {
  },
  onKeyPressHandler: () => {
  },
  onKeyUpHandler: () => {
  },
  onKeyDownHandler: () => {
  },
  onClickHandler: () => {
  },
};

export default CoreNumericInputComponent;
